import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import Swal from 'sweetalert2';
import { Globals } from '../../_models/globals';
import { NotaFiscal, PedidoNotaFiscal } from './_models/pedidonotafiscal';
import { SweetAlertParams } from 'app/_models/notificationParams.model';
import { Transportadora } from '../../_models/transportadora';

import { NotaFiscalService } from './notafiscal.service';
import { NotificationService } from 'app/_services/notification.service';

declare const $: any;
declare const isEmpty: any;
declare const sort_by: any;

declare const notaFiscalChangeTransportadora: any;

@Component({
    selector: 'app-nota-fiscal', templateUrl: './notafiscal.component.html', styleUrls: ['./notafiscal.component.scss'],
    standalone: false
})
export class NotaFiscalComponent implements OnInit
{
    @Input() is_seller: boolean;
    @Input() is_central: boolean;
    @Input() pdf_viewer_class: string;
    @Input() pedido: PedidoNotaFiscal;
    @Input() permitirSalvar: boolean = true;
    @Input() showTransportadora: boolean = true;
    @Input() transportadoras: Transportadora[] = [];
    @Output() excluirNota = new EventEmitter();
    @Output() salvarTransportadora = new EventEmitter();
    pdfSrc: string;
    pdfSrcDownload: string;
    visaoPDF: boolean;

    constructor(private nfService: NotaFiscalService, private notificationService: NotificationService, private globals: Globals)
    { }

    ngOnInit(): void {
        if (!isEmpty(this.pedido) && !isEmpty(this.pedido.notasFiscais))
        {
            this.selecionarNotaUrl(this.pedido.notasFiscais[0].url);
            this.visaoPDF = this.pedido.notasFiscais.length === 1;
        }

        this.registerObservables();
    }

    baixarNota(nota_url: string)
    {
        try
        {
            window.open(nota_url);
            //window.open("https://vadimdez.github.io/ng2-pdf-viewer/assets/pdf-test.pdf");
        }
        catch (e)
        {
            console.log(e);
        }
    }

    async _excluirNota(nota_url: string)
    {
        if (await this.notificationService.showConfirmationDialog('componente.nota-fiscal.tabela.nota.excluir.confirm'))
        {
            let indice = this.pedido.notasFiscais.findIndex(n => n.url === nota_url);
            this.pedido.notasFiscais.splice(indice, 1);

            this.excluirNota.emit({ nota_url });

            if (this.pedido.notasFiscais.length === 1)
                this.selecionarNotaUrl(this.pedido.notasFiscais[0].url);
            else
                this.visaoPDF = false;
        }
    }

    async modalTransportadoraAbrir(nota: NotaFiscal, isUploadNF: boolean = false) {
        if (!this.transportadoras)
            return;

        const disabled = !this.permitirSalvar ? ' disabled' : '';
        let html = ` <div style="display: flex; flex-direction: column;">
                        <h2 style="font-size: 16px; margin-bottom: 20px; margin-top: 0;">${this.globals.translate('componente.nota-fiscal.modal.titulo')}</h2>
                        <div style="align-items: center; display: flex; margin-bottom: 10px; text-align: start;">
                            <span style="font-size: 15px; margin-right: 10px; white-space: nowrap;">${this.globals.translate('componente.nota-fiscal.modal.transportadora.label')}</span>
                            <select class="form-select form-select-sm transportadoras" ${disabled}></select>
                            <input type="text" class="form-control form-control-sm nome-transportadora" style="display: none; margin-left: 10px;" maxlength="100" placeholder="${this.globals.translate('componente.nota-fiscal.modal.transportadora.placeholder')}" />
                        </div>
                        <div style="align-items: center; display: flex; text-align: start;">
                            <span style="font-size: 15px; margin-right: 10px; white-space: nowrap;">${this.globals.translate('componente.nota-fiscal.modal.codigo-rastreio.label')}</span>
                            <input type="text" class="form-control form-control-sm text-uppercase codigo-rastreio" maxlength="100" ${disabled} />
                        </div>
                    </div>`

        const params: SweetAlertParams = {
            showConfirmButton: this.permitirSalvar,
            cancelButtonText: isUploadNF ? 'componente.nota-fiscal.modal.botoes.deixar-depois' : 'elemento.generico-botao.cancelar',
            confirmButtonText: 'elemento.generico-botao.salvar',
            isHtml: true,
            message: html,
            didOpen: () => {
                $('.transportadoras').empty();
                $('.transportadoras').on('change', notaFiscalChangeTransportadora);
                $('.transportadoras').append($("<option />").val('').text(''));

                $.each(this.transportadoras, function () { $('.transportadoras').append($("<option />").val(this.id).text(this.name)); });

                if (nota.shipping_company_id) {
                    $('.transportadoras').val(nota.shipping_company_id);

                    if (nota.shipping_company_id == 99)
                        $('.nome-transportadora').val(nota.shipping_company_name).show();
                }

                $('.codigo-rastreio').val(nota.shipping_company_tracking_code);
            },
            preConfirm: () => {
                const shipping_company_id = $('.transportadoras').val();
                const shipping_company_name = $('.nome-transportadora').val()?.trim();
                const shipping_company_tracking_code = $('.codigo-rastreio').val()?.trim().toUpperCase();
                const nota_fiscal = nota.numero;

                let errorMessage = [];

                if (shipping_company_id == '99' && isEmpty(shipping_company_name))
                    errorMessage.push(`- ${this.globals.translate('componente.nota-fiscal.modal.transportadora.outra-obrigatoria')}`);

                if (errorMessage.length > 0) {
                    Swal.showValidationMessage(errorMessage.join('<br />'))
                    return false;
                }

                return { quotation_id: this.pedido.quotation_id, order_id: this.pedido.order_id, nota_fiscal, shipping_company_id, shipping_company_name, shipping_company_tracking_code };
            }
        }

        this.notificationService.showConfirm(params).then((result) => {
            if (result.isConfirmed)
                this.salvarTransportadora.emit(result.value);
        });
    }

    selecionarNota(nota: NotaFiscal) {
        this.selecionarNotaUrl(nota.url);
        this.visaoPDF = true;
    }

    selecionarNotaUrl(nota_url: string) {
        this.pdfSrc = nota_url;
    }

    registerObservables() {
        this.nfService.SelecionarNota.subscribe(data =>
        {
            this.selecionarNota(data);
        });
    }

    get _visaoPDF()
    {
        if (isEmpty(this.pedido) || isEmpty(this.pedido.notasFiscais))
            return false;

        if (this.pedido.notasFiscais.length === 1)
            return true;

        return this.visaoPDF;
    }

    get notasFiscaisOrdenadas(): NotaFiscal[]
    {
        if (!this.pedido || this.pedido.notasFiscais.length == 0)
            return [];

        return this.pedido?.notasFiscais.sort(sort_by([{ name: 'numero' }]));
    }
}
